// extracted by mini-css-extract-plugin
export var divider = "_uq-0";